import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { TABLE_TABS_ENUM } from "./types";

export const getTableSortFilterByTableName = createSelector(
  [
    (state: RootState, tableName: TABLE_TABS_ENUM) =>
      state.tableFilters[tableName].filters.sortField,
    (state: RootState, tableName: TABLE_TABS_ENUM) =>
      state.tableFilters[tableName].filters.sortOrder,
  ],
  (sortField, sortOrder) => ({ sortField, sortOrder })
);
